import React from 'react'

const Section: React.FC = ({ children }) => {
  return <div className="bg-white md:rounded-lg md:shadow-lg">{children}</div>
}

export { Section }
